import React from "react";
import { Row, Col, FormGroup } from "react-bootstrap";
import InputError from "app/Components/_form/InputError/InputError";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import Label from "app/Components/_form/Label/Label";
import {
  employeeFormLabel,
  employeeMedicalEligibilityList,
  employeeMedicalCategoryList,
} from "../Constant";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
function EmployeeMedicalHistoryForm({ form = {}, onChange, error = {}, siteList }) {
  return (
    <>
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>{employeeFormLabel["specialMedicalExamCategory"]}</Label>

            <SimpleSelect
              name={"smeCategory"}
              value={form?.smeCategory}
              onChange={onChange}
              options={employeeMedicalCategoryList}
              label={"name"}
              id="value"
              placeHolder={employeeFormLabel["specialMedicalExamCategory"]}
              menuPortalTarget={null}
            />
            <InputError error={error["smeCategory"]} />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label>{employeeFormLabel["specialMedicalExamEligibility"]}</Label>

            <SimpleSelect
              name={"specialMedicalExamEligibility"}
              value={form?.specialMedicalExamEligibility.toLowerCase()}
              onChange={onChange}
              options={employeeMedicalEligibilityList}
              placeHolder={employeeFormLabel["specialMedicalExamEligibility"]}
              label={"name"}
              id="value"
              menuPortalTarget={null}
            />
            <InputError error={error["specialMedicalExamEligibility"]} />
          </FormGroup>
        </Col>

        <Col md={6}>
          <FormGroup>
            <Label>{employeeFormLabel["effectiveDate"]}</Label>

            <DatePicker
              name={"effectiveDate"}
              value={form?.effectiveDate}
              onChangeDate={onChange}
              // onChange={(moment, name) =>
              //   onChange({
              //     target: {
              //       name: name,
              //       value: moment.format("YYYY-MM-DD HH:mm:ss"),
              //     },
              //   })
              // }
              label={employeeFormLabel["effectiveDate"]}
              placeHolder={employeeFormLabel["effectiveDate"]}
              error={error["effectiveDate"]}
              menuPortalTarget={null}
            />
            <InputError error={error["effectiveDate"]} />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
}

export default EmployeeMedicalHistoryForm;
